//@flow
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { withRouter } from 'react-router-dom';
import { useViewport } from 'components/templates/viewportProvider';
import { RouteUtil } from 'utils/RouteUtil';
import RecommendedCarousel from 'components/organisms/recommendedCarousel';
import RecommendedMobileCarousel from 'components/organisms/recommendedMobileCarousel';

import './styles.scss';

type Props = {
  data: Array,
};

const RecommendedSection = (props: Props) => {
  const { data, breadcrumbList } = props;
  const { height } = useViewport();
  const checkType = data.type;

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 1224px)',
  });
  const isBigScreen = useMediaQuery({ query: '(min-device-width: 1824px)' });
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({
    query: '(max-device-width: 1224px)',
  });
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  const goToProjectDetails = (
    urlSlug,
    projectSlug,
    productSlug,
    isCompletedProject
  ) => {
    if (checkType !== 'rentals') {
      RouteUtil.setRouteChange(props, `/${urlSlug}`);
      window.location.reload();
    } else if (isCompletedProject) {
      RouteUtil.setRouteChange(props, `/rentals/${urlSlug}`);
      window.location.reload();
    } else {
      RouteUtil.setRouteChange(
        props,
        `/rentals/${projectSlug}/${productSlug}/${urlSlug}`
      );
      window.location.reload();
    }
  };
  return (
    <div style={{ height }} id={'recommended'}>
      {(isDesktopOrLaptop || isBigScreen || isPortrait === false) && (
        <>
          <RecommendedCarousel
            recommendedList={data.data}
            fetchTitle={
              <h2>
                Other Properties <br />
                You Might Like
              </h2>
            }
            displayHeader={true}
            isDefinedRoute={false}
            type={data.type}
            onClick={
              data.type === 'rentals'
                ? data =>
                    goToProjectDetails(
                      data.urlSlug,
                      data.projectSlug,
                      data.productSlug,
                      data.isCompletedProject
                    )
                : data => goToProjectDetails(data.urlSlug)
            }
            breadcrumbList={breadcrumbList}
          />
        </>
      )}

      {(isTabletOrMobileDevice || isTabletOrMobile) && isPortrait === true && (
        <RecommendedMobileCarousel
          recommendedList={data.data}
          fetchTitle={
            data.type === 'rentals' ? (
              <h3 className={'project-recommended-section'}>
                More Rental Properties <br />
                You Might Like
              </h3>
            ) : (
              <h3 className={'project-recommended-section'}>
                Other properties <br />
                you might like
              </h3>
            )
          }
          isDisplayLocationIcon={true}
          type={data.type}
          isDefinedRoute={false}
          onClick={
            data.type === 'rentals'
              ? data =>
                  goToProjectDetails(
                    data.urlSlug,
                    data.projectSlug,
                    data.productSlug,
                    data.isCompletedProject
                  )
              : data => goToProjectDetails(data.urlSlug)
          }
          breadcrumbList={breadcrumbList}
        />
      )}
    </div>
  );
};
export default withRouter(RecommendedSection);
